/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessPreviewDirectoryRoleSetup } from "../funcs/accessPreviewDirectoryRoleSetup.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { DirectoryRoleSetupPreviewResult } from "../models/components/directoryrolesetuppreviewresult.js";
import {
  PreviewDirectoryRoleSetupRequest,
  PreviewDirectoryRoleSetupSecurity,
} from "../models/operations/previewdirectoryrolesetup.js";
import { unwrapAsync } from "../types/fp.js";
export type DirectoryRoleSetupPreviewQueryData =
  DirectoryRoleSetupPreviewResult;

export function prefetchDirectoryRoleSetupPreview(
  queryClient: QueryClient,
  client$: GramCore,
  request?: PreviewDirectoryRoleSetupRequest | undefined,
  security?: PreviewDirectoryRoleSetupSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildDirectoryRoleSetupPreviewQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildDirectoryRoleSetupPreviewQuery(
  client$: GramCore,
  request?: PreviewDirectoryRoleSetupRequest | undefined,
  security?: PreviewDirectoryRoleSetupSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<DirectoryRoleSetupPreviewQueryData>;
} {
  return {
    queryKey: queryKeyDirectoryRoleSetupPreview({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function directoryRoleSetupPreviewQueryFn(
      ctx,
    ): Promise<DirectoryRoleSetupPreviewQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessPreviewDirectoryRoleSetup(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyDirectoryRoleSetupPreview(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "previewDirectoryRoleSetup", parameters];
}
